module.exports = __webpack_public_path__ + "static/DJS1-9332ffc08fb8668b924447ea74e4db4e.png";